import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { ProjetoEquipe } from '../../../models/projeto-equipe.model';
import { ProjetoEquipeCapacidadeExecucaoService } from '../../../services/projeto-equipe-capacidade-execucao.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjetoCadastro } from '../../../models/projeto-cadastro.model';

@Component({
  selector: 'app-equipe-capacidade-execucao-list',
  templateUrl: './equipe-capacidade-execucao-list.component.html',
  styleUrls: ['./equipe-capacidade-execucao-list.component.scss'],
})
export class EquipeCapacidadeExecucaoListComponent
  extends BaseListComponent<ProjetoEquipe>
  implements OnInit, OnDestroy
{
  idProjeto: any;
  equipeList: ProjetoEquipe[];
  projeto: ProjetoCadastro;
  permissoes: any;
  equipeReadyList: Array<{ id: number; label: string }> = [];
  loadCadastro: boolean = false;

  constructor(
    private myService: ProjetoEquipeCapacidadeExecucaoService,
    public activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    super();
  }

  ngOnInit() {
    let currentUrl = this.router.url;
    const regex = /projeto\/(\d+)\/equipe/;
    const match = currentUrl.match(regex);

    if (match) {
      this.idProjeto = match[1];
      this.initLoadDataTable();
    } else {
      console.log('ID não encontrado');
    }
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initLoadDataTable() {
    this.addSub(
      this.myService.getListAll(this.idProjeto).subscribe((res) => {
        this.equipeList = res['list'];
        this.permissoes = res['permissoes'];
        this.projeto = res['project'];
        this.equipeReadyList = res['equipeReadyList'];
        this.loadCadastro = true;
        this.loaded();
      })
    );
  }

  novo() {
    return ['adicionar'];
  }

  editar(id: number) {
    return ['/pre-projeto/projeto/equipe', id];
  }
}
